import React,{useState,useEffect} from 'react'
import Sidebar from "../Sidebar";
import Header from "../Header";
import { message } from 'antd';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { DatePicker } from 'antd';
import moment from 'moment';
import HolidayHeader from './HolidayHeader';

function UpdateHoliday(props) {
  console.log("props---->", props)
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const history = useHistory()
    const [showModal,setShowModal]=useState(false)
    const [update,setUpdate]=useState(false)
  

  const [reason, setReason] = useState();
  const [startDate, setStartdate] = useState(null);
  const [endDate, setEnddate] = useState(null);
  const [status, setStatus] = useState();
  useEffect(() => {
    if (props.location.state) {
      setReason(props.location.state.reason || "");
      setStartdate(props.location.state.startDate ? moment(props.location.state.startDate) : null);
      setEnddate(props.location.state.endDate ? moment(props.location.state.endDate) : null);
      setStatus(props.location.state.status || false);
    }
  }, []);
  
  

      const UpdateHoliday = (id) => {
        return e => {
          e.preventDefault()
       
          var axios = require("axios");
      
          if (!reason || !startDate || !endDate || status === "") {
            message.error("All fields must be filled correctly.");
            return;
        }

        const data = {
          reason,
          startdate:  startDate.format('YYYY-MM-DD') ,
          enddate:  endDate.format('YYYY-MM-DD') ,
          status: status
        };
        
      console.log("data ------------> ", data)
          var config = {
            method: "put",
            url: `https://adminapi.youjifresh.com/holidays/${id}`,
            headers: {
              Authorization: "Bearer " + sessionStorage.getItem("youji_token"),
              "Content-Type": "application/json",
            },
            data: data,
          };
      
          axios(config)
            .then(function (response) {
              console.log(JSON.stringify(response.data));
              message.success("holidays Updated");
              setShowModal(false)
                history.push('/holidays')
             
            })
            .catch(function (error) {
              console.log(error);
              message.error(error.response.data.message);
            });
          setUpdate(false)
        }
      }
    
      const cancel = () => {
        setShowModal(false)
        history.push('/holidays')

      }
    
    return (
       <>
          <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/*  Site header */}
        <HolidayHeader sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <main>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {/* Page header */}
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
              {/* Left: Title */}
              <div className="mb-4 sm:mb-0">
                <h1 className="text-2xl p-6 md:text-3xl text-gray-800 font-bold">
                  Update Holiday
                </h1>
              </div>

              <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">

                
              </div>
            </div>
         

            {/* Table */}
            <div className="relative px-4 flex-auto">
                        <form id="form_add_Coupon">
                          <div class="flex flex-wrap -mx-2 mb-2">
                            
                          <div class="w-full md:w-1/2 p-2 mb-6 md:mb-0">
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                for="form__coupon_code"
                              >
                                Reason
                              </label>
                              
                              <input
                                class="appearance-none block text-clip resize-y overflow-hidden w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                id="form__coupon_code"
                                type="text"
                                value={reason}
                                onChange={(e) => {
                               
                                  setReason(e.target.value)
                                }}
                                placeholder="Reason"
                              />
                            </div>

                            <div class="w-full md:w-1/2 p-2 mb-6 md:mb-0">
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                for="form__coupon_active"
                              >
                                Status
                              </label>
                              <div className='relative'>
                            <select
                                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                  id="form__coupon_active"
                                  value={status}
                                  onChange={(e) => {
                                    
                                    setStatus(e.target.value)
                                  }}
                                >
                                  <option value={""}>{'Select'}</option>
                                  <option value={true} selected={status === true}>True</option>
                                  <option value={false} selected={status === false}>False</option>         
                                  
                                  
                                </select>
                                </div>
                            </div>


                           
                           
                          

                            <div class="w-full md:w-1/2 p-2 mb-5 mt-2 md:mb-0">
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                for="form__coupon_exp_date"
                              >
                                Start Date
                              </label>
                              <div class="relative">
                              
                                <DatePicker
                                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                  id="form__coupon_exp_date"
                                  isclearable
                                  value={startDate ? moment(startDate) : null}
  onChange={(date) => setStartdate(date)}
                                
                                
                                />
                              </div>
                            </div>
                            <div class="w-full md:w-1/2 p-2 mb-5 mt-2 md:mb-0">
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                for="form__coupon_exp_date"
                              >
                                End Date
                              </label>
                              <div class="relative">
                              
                                <DatePicker
                                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                  id="form__coupon_exp_date"
                                  isclearable
                                  value={endDate ? moment(endDate) : null}
                                  onChange={(date) => setEnddate(date)}
                                
                                />
                              </div>
                            </div>
                           
                          </div>
                        </form>
                      </div>
                     
                      <div className="flex items-center  p-6 border-t border-solid border-blueGray-200 rounded-b">
                        
                        <div className="justify-items-end ">
                          <button
                            className="btn bg-red-500  hover:bg-red-600 text-white mr-2"
                            onClick={cancel}
                          >
                            <span className="hidden xs:block">Cancel</span>
                          </button>
                          {/* {
                            update ? 
                            <button
                            className="btn bg-yellow-500 hover:bg-yellow-600 text-white"
                            onClick={UpdateHoliday(props.location.state.id)} 
                          >
                            <span className="hidden xs:block">
                              Update 
                            </span>
                          </button>: <button
                            className="btn bg-yellow-500 opacity-50 text-white"
                            disabled
                          >
                            <span className="hidden xs:block">
                              Update 
                            </span>
                          </button>
                          } */}
                           <button
                            className="btn bg-yellow-500 hover:bg-yellow-600 text-white"
                            onClick={UpdateHoliday(props.location.state.id)} 
                          >
                            <span className="hidden xs:block">
                              Update 
                            </span>
                          </button>
                        </div>
                      </div>
           
            {/* Pagination */}
            
          </div>
        </main>
      </div>
    </div>
       </>
    )
}

export default UpdateHoliday
